import { CountryCodesAlpha2 } from '@xing-com/crate-common-graphql-types';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import type { JobDetailsVisibleJobFragment } from '@xing-com/crate-jobs-graphql';
import { useUserCountry } from '@xing-com/crate-jobs-hooks';
import { useFeatureSwitch } from '@xing-com/hub';

const countries = new Set([
  CountryCodesAlpha2.At,
  CountryCodesAlpha2.Be,
  CountryCodesAlpha2.Bg,
  CountryCodesAlpha2.Hr,
  CountryCodesAlpha2.Cy,
  CountryCodesAlpha2.Cz,
  CountryCodesAlpha2.Dk,
  CountryCodesAlpha2.Ee,
  CountryCodesAlpha2.Fi,
  CountryCodesAlpha2.Fr,
  CountryCodesAlpha2.De,
  CountryCodesAlpha2.Gr,
  CountryCodesAlpha2.Hu,
  CountryCodesAlpha2.Ie,
  CountryCodesAlpha2.It,
  CountryCodesAlpha2.Lv,
  CountryCodesAlpha2.Lt,
  CountryCodesAlpha2.Lu,
  CountryCodesAlpha2.Mt,
  CountryCodesAlpha2.Nl,
  CountryCodesAlpha2.Pl,
  CountryCodesAlpha2.Pt,
  CountryCodesAlpha2.Ro,
  CountryCodesAlpha2.Sk,
  CountryCodesAlpha2.Si,
  CountryCodesAlpha2.Es,
  CountryCodesAlpha2.Se,
  CountryCodesAlpha2.Is,
  CountryCodesAlpha2.Li,
  CountryCodesAlpha2.No,
  CountryCodesAlpha2.Ch,
]);

export const useIsFencedJob = (job?: JobDetailsVisibleJobFragment): boolean => {
  const { isLoggedIn } = useLoginState();
  const isJobFenceEnabled = useFeatureSwitch('enable_job_fence', false);
  const isJobFencingEligible =
    isJobFenceEnabled &&
    isLoggedIn &&
    !!job?.paid &&
    job?.serviceOfferingGroup > 0;
  const { country } = useUserCountry({
    skip: !isJobFencingEligible,
  });

  return isJobFencingEligible && (!country || !countries.has(country));
};
